import { Tabs as MantineTabs, TabsProps } from "@mantine/core";

import classes from "./Tabs.module.css";
export const Tabs = (props: TabsProps) => <MantineTabs classNames={classes} {...props} />;

Tabs.List = MantineTabs.List;
Tabs.Tab = MantineTabs.Tab;
Tabs.Panel = MantineTabs.Panel;
